import { render, staticRenderFns } from "./ContactPickerWithButtonEl.vue?vue&type=template&id=2a488292&scoped=true&"
import script from "./ContactPickerWithButtonEl.vue?vue&type=script&lang=ts&"
export * from "./ContactPickerWithButtonEl.vue?vue&type=script&lang=ts&"
import style0 from "./ContactPickerWithButtonEl.vue?vue&type=style&index=0&id=2a488292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a488292",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
